import * as moment from 'moment';

export class FriendlyDateValueConverter {
    toView(value: Date) {
        return moment(value).format('dddd, MMMM Do');
    }
}